import { render, staticRenderFns } from "./BarContactForm.vue?vue&type=template&id=0b2cfad6&scoped=true"
import script from "./BarContactForm.vue?vue&type=script&lang=js"
export * from "./BarContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2cfad6",
  null
  
)

export default component.exports